(() => {
  'use strict';

  if (window.__treedixPdpV2Controller && typeof window.__treedixPdpV2Controller.destroy === 'function') {
    window.__treedixPdpV2Controller.destroy();
  }

  const icon = {
    zoomIn: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M10.5 7.5v6M7.5 10.5h6M15.3 15.3 21 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    zoomOut: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M7.5 10.5h6M15.3 15.3 21 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    fit: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 4 4 9M15 4l5 5M9 20l-5-5M15 20l5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    fullscreenEnter: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 9 4 4M15 9l5-5M9 15l-5 5M15 15l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    fullscreenExit: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 8h4V4M20 8h-4V4M4 16h4v4M20 16h-4v4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 4l5 5M20 4l-5 5M4 20l5-5M20 20l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
  };

  const scaleLevels = [1, 1.25, 1.5, 2, 2.5, 3, 4];
  const listeners = [];
  const galleryHandlers = new WeakMap();

  const state = {
    overlay: null,
    gallery: null,
    media: [],
    index: 0,
    scale: 1,
    translateX: 0,
    translateY: 0,
    isDragging: false,
    pointerId: null,
    dragStartX: 0,
    dragStartY: 0,
    startTranslateX: 0,
    startTranslateY: 0,
    rafId: 0,
    pendingX: 0,
    pendingY: 0,
    touchStartX: 0,
    touchStartY: 0,
    touchCanSwipe: true,
    scrollY: 0,
    previousBody: {},
    lastFocused: null
  };

  const on = (target, type, handler, options) => {
    if (!target || !target.addEventListener) return;
    target.addEventListener(type, handler, options);
    listeners.push([target, type, handler, options]);
  };

  const removeNode = (node) => {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  };

  const cleanupLightboxNodes = () => {
    document.querySelectorAll('[data-treedix-lightbox-root], .treedix-media-lightbox, .treedix-lightbox').forEach((node) => {
      if (node !== state.overlay) removeNode(node);
    });
  };

  const pauseMedia = (root) => {
    if (!root) return;
    root.querySelectorAll('video').forEach((video) => { try { video.pause(); } catch (error) {} });
    root.querySelectorAll('iframe').forEach((iframe) => {
      const src = iframe.getAttribute('src');
      if (src) iframe.setAttribute('src', src);
    });
  };

  const getThumbs = (gallery) => Array.from(gallery.querySelectorAll('[data-pdp-v2-thumb]'));
  const getActiveThumb = (gallery) => gallery.querySelector('[data-pdp-v2-thumb].is-active, [data-pdp-v2-thumb][aria-current="true"]') || gallery.querySelector('[data-pdp-v2-thumb]');
  const getPanelByMediaId = (gallery, mediaId) => Array.from(gallery.querySelectorAll('[data-pdp-v2-panel]')).find((panel) => String(panel.dataset.mediaId) === String(mediaId));

  const syncArrows = (gallery) => {
    const prev = gallery.querySelector('[data-pdp-v2-thumb-prev]');
    const next = gallery.querySelector('[data-pdp-v2-thumb-next]');
    const disabled = getThumbs(gallery).length < 2;
    if (prev) prev.disabled = disabled;
    if (next) next.disabled = disabled;
  };

  const selectMedia = (gallery, mediaId, options = {}) => {
    const main = gallery.querySelector('[data-pdp-v2-main]');
    const panels = Array.from(gallery.querySelectorAll('[data-pdp-v2-panel]'));
    const thumbs = getThumbs(gallery);
    const targetPanel = panels.find((panel) => String(panel.dataset.mediaId) === String(mediaId));
    const targetThumb = thumbs.find((thumb) => String(thumb.dataset.mediaId) === String(mediaId));
    if (!main || !targetPanel || !targetThumb) return;

    panels.forEach((panel) => {
      const active = panel === targetPanel;
      if (!active) pauseMedia(panel);
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });

    thumbs.forEach((thumb) => {
      const active = thumb === targetThumb;
      thumb.classList.toggle('is-active', active);
      if (active) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });

    const mediaType = targetPanel.dataset.mediaType || targetThumb.dataset.mediaType || 'image';
    const index = thumbs.indexOf(targetThumb);
    const counter = gallery.querySelector('[data-pdp-v2-counter]');
    const type = gallery.querySelector('[data-pdp-v2-type]');
    main.classList.toggle('is-video-active', mediaType !== 'image');
    gallery.dataset.activeMediaId = String(mediaId);
    if (counter) counter.textContent = `${index + 1} / ${thumbs.length}`;
    if (type) type.textContent = mediaType.indexOf('video') !== -1 ? 'Video' : (mediaType === 'image' ? 'Photos' : 'Media');
    if (options.scroll !== false) targetThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    syncArrows(gallery);
  };

  const stepMainMedia = (gallery, direction) => {
    const thumbs = getThumbs(gallery);
    if (thumbs.length < 2) return;
    const active = getActiveThumb(gallery);
    const currentIndex = Math.max(0, thumbs.indexOf(active));
    const nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
    selectMedia(gallery, thumbs[nextIndex].dataset.mediaId);
  };

  const getMediaItems = (gallery) => getThumbs(gallery).map((thumb, index) => {
    const mediaId = thumb.dataset.mediaId;
    const panel = getPanelByMediaId(gallery, mediaId);
    return { thumb, panel, mediaId, index, type: thumb.dataset.mediaType || (panel && panel.dataset.mediaType) || 'image' };
  }).filter((item) => item.panel && item.mediaId);

  const getActiveMediaId = (gallery) => {
    const activeThumb = getActiveThumb(gallery);
    const activePanel = gallery.querySelector('[data-pdp-v2-panel].is-active');
    return (activeThumb && activeThumb.dataset.mediaId) || (activePanel && activePanel.dataset.mediaId) || gallery.dataset.activeMediaId;
  };

  const isBrowserFullscreen = () => !!state.overlay && (document.fullscreenElement === state.overlay || document.webkitFullscreenElement === state.overlay);
  const isCurrentImage = () => state.media[state.index] && state.media[state.index].type === 'image';
  const getStage = () => state.overlay && state.overlay.querySelector('[data-lightbox-stage]');
  const getTransform = () => state.overlay && state.overlay.querySelector('[data-lightbox-media-transform]');

  const resetTransform = () => {
    state.scale = 1;
    state.translateX = 0;
    state.translateY = 0;
    state.isDragging = false;
    applyTransform();
  };

  const getDragBounds = () => {
    const stage = getStage();
    const transform = getTransform();
    if (!stage || !transform || !isCurrentImage()) return { x: 0, y: 0 };
    const media = transform.querySelector('img');
    if (!media) return { x: 0, y: 0 };
    const stageRect = stage.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    const baseWidth = mediaRect.width / Math.max(state.scale, 1);
    const baseHeight = mediaRect.height / Math.max(state.scale, 1);
    return {
      x: Math.max(0, (baseWidth * state.scale - stageRect.width) / 2),
      y: Math.max(0, (baseHeight * state.scale - stageRect.height) / 2)
    };
  };

  const clampTranslate = () => {
    const bounds = getDragBounds();
    state.translateX = Math.max(-bounds.x, Math.min(bounds.x, state.translateX));
    state.translateY = Math.max(-bounds.y, Math.min(bounds.y, state.translateY));
    if (!bounds.x) state.translateX = 0;
    if (!bounds.y) state.translateY = 0;
  };

  function applyTransform() {
    const overlay = state.overlay;
    const transform = getTransform();
    if (!overlay || !transform) return;
    clampTranslate();
    transform.style.setProperty('--treedix-lightbox-scale', String(state.scale));
    transform.style.setProperty('--treedix-lightbox-x', `${state.translateX}px`);
    transform.style.setProperty('--treedix-lightbox-y', `${state.translateY}px`);
    overlay.classList.toggle('is-image-media', isCurrentImage());
    overlay.classList.toggle('is-zoomed', isCurrentImage() && state.scale > 1);
    overlay.classList.toggle('is-dragging', state.isDragging);
  }

  const setScale = (value) => {
    state.scale = Math.max(scaleLevels[0], Math.min(scaleLevels[scaleLevels.length - 1], Number(value) || 1));
    if (state.scale <= 1) {
      state.scale = 1;
      state.translateX = 0;
      state.translateY = 0;
    }
    applyTransform();
  };

  const zoom = (direction) => {
    if (!isCurrentImage()) return;
    const current = state.scale;
    const next = direction > 0 ? (scaleLevels.find((level) => level > current + 0.001) || scaleLevels[scaleLevels.length - 1]) : ([...scaleLevels].reverse().find((level) => level < current - 0.001) || scaleLevels[0]);
    setScale(next);
  };

  const updateFullscreenButton = () => {
    const button = state.overlay && state.overlay.querySelector('[data-lightbox-fullscreen]');
    if (!button) return;
    const active = isBrowserFullscreen();
    const supported = !!(state.overlay.requestFullscreen || state.overlay.webkitRequestFullscreen || document.exitFullscreen || document.webkitExitFullscreen);
    button.disabled = !supported;
    button.innerHTML = active ? icon.fullscreenExit : icon.fullscreenEnter;
    button.setAttribute('aria-label', active ? 'Exit full screen' : 'Enter full screen');
    button.setAttribute('title', active ? 'Exit full screen' : 'Enter full screen');
    requestAnimationFrame(applyTransform);
  };

  const toggleFullscreen = () => {
    if (!state.overlay) return;
    if (isBrowserFullscreen()) {
      const exit = document.exitFullscreen || document.webkitExitFullscreen;
      if (exit) exit.call(document);
      return;
    }
    const request = state.overlay.requestFullscreen || state.overlay.webkitRequestFullscreen;
    if (request) request.call(state.overlay);
  };

  const lockPage = () => {
    const body = document.body;
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    state.previousBody = { position: body.style.position, top: body.style.top, width: body.style.width, overflow: body.style.overflow, paddingRight: body.style.paddingRight };
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    body.classList.add('treedix-media-lightbox-lock');
    body.style.position = 'fixed';
    body.style.top = `-${state.scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
  };

  const unlockPage = () => {
    const body = document.body;
    body.classList.remove('treedix-media-lightbox-lock');
    body.style.position = state.previousBody.position || '';
    body.style.top = state.previousBody.top || '';
    body.style.width = state.previousBody.width || '';
    body.style.overflow = state.previousBody.overflow || '';
    body.style.paddingRight = state.previousBody.paddingRight || '';
    window.scrollTo(0, state.scrollY || 0);
  };

  const closeLightbox = () => {
    const overlay = state.overlay;
    if (!overlay || overlay.hidden) return;
    if (isBrowserFullscreen()) {
      const exit = document.exitFullscreen || document.webkitExitFullscreen;
      if (exit) exit.call(document);
    }
    pauseMedia(overlay);
    overlay.classList.remove('is-open', 'is-image-media', 'is-zoomed', 'is-dragging');
    overlay.hidden = true;
    unlockPage();
    if (state.lastFocused && typeof state.lastFocused.focus === 'function') setTimeout(() => state.lastFocused.focus({ preventScroll: true }), 0);
    state.gallery = null;
    state.media = [];
    resetTransform();
  };

  const createOverlay = () => {
    cleanupLightboxNodes();
    const overlay = document.createElement('div');
    overlay.className = 'treedix-media-lightbox';
    overlay.dataset.treedixLightboxRoot = 'true';
    overlay.hidden = true;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product media viewer');
    overlay.innerHTML = `
      <div class="treedix-media-lightbox__topbar">
        <button class="treedix-media-lightbox__icon" type="button" data-lightbox-zoom-in aria-label="Zoom in" title="Zoom in">${icon.zoomIn}</button>
        <button class="treedix-media-lightbox__icon" type="button" data-lightbox-zoom-out aria-label="Zoom out" title="Zoom out">${icon.zoomOut}</button>
        <button class="treedix-media-lightbox__icon" type="button" data-lightbox-fit aria-label="Fit image to screen" title="Fit image to screen">${icon.fit}</button>
        <button class="treedix-media-lightbox__icon" type="button" data-lightbox-fullscreen aria-label="Enter full screen" title="Enter full screen">${icon.fullscreenEnter}</button>
        <button class="treedix-media-lightbox__icon" type="button" data-lightbox-close aria-label="Close media viewer" title="Close">${icon.close}</button>
      </div>
      <div class="treedix-media-lightbox__count" data-lightbox-count></div>
      <div class="treedix-media-lightbox__stage-wrap" data-lightbox-backdrop>
        <button class="treedix-media-lightbox__arrow treedix-media-lightbox__arrow--prev" type="button" data-lightbox-prev aria-label="Previous media">‹</button>
        <div class="treedix-media-lightbox__stage" data-lightbox-stage><div class="treedix-media-lightbox__media-transform" data-lightbox-media-transform></div></div>
        <button class="treedix-media-lightbox__arrow treedix-media-lightbox__arrow--next" type="button" data-lightbox-next aria-label="Next media">›</button>
      </div>
      <div class="treedix-media-lightbox__footer"><div class="treedix-media-lightbox__thumbs" data-lightbox-thumbs aria-label="Product media thumbnails"></div></div>`;
    document.body.appendChild(overlay);
    state.overlay = overlay;
    bindOverlay(overlay);
    return overlay;
  };

  const ensureOverlay = () => state.overlay && document.body.contains(state.overlay) ? state.overlay : createOverlay();

  const makeLightboxMedia = (item) => {
    if (item.type === 'image') {
      const source = item.thumb.dataset.zoomUrl || item.thumb.dataset.imageUrl;
      const original = item.panel.querySelector('img');
      const img = document.createElement('img');
      img.src = source || (original && (original.currentSrc || original.src)) || '';
      img.alt = (original && original.alt) || item.thumb.getAttribute('aria-label') || '';
      img.decoding = 'async';
      img.draggable = false;
      return img;
    }
    const media = item.panel.querySelector('video, iframe, model-viewer');
    if (media) {
      const clone = media.cloneNode(true);
      if (clone.tagName === 'VIDEO') {
        clone.controls = true;
        clone.playsInline = true;
        clone.preload = 'metadata';
        clone.removeAttribute('autoplay');
      }
      return clone;
    }
    const fallback = document.createElement('div');
    fallback.textContent = item.type.replace('_', ' ');
    return fallback;
  };

  const updateZoomButtons = (item) => {
    const isImage = item && item.type === 'image';
    state.overlay.querySelectorAll('[data-lightbox-zoom-in], [data-lightbox-zoom-out], [data-lightbox-fit]').forEach((button) => { button.disabled = !isImage; });
    state.overlay.classList.toggle('is-image-media', !!isImage);
    updateFullscreenButton();
  };

  const renderLightbox = (index) => {
    const overlay = ensureOverlay();
    if (!state.media.length) return;
    const total = state.media.length;
    state.index = ((index % total) + total) % total;
    const item = state.media[state.index];
    pauseMedia(overlay);
    resetTransform();
    const transform = overlay.querySelector('[data-lightbox-media-transform]');
    const count = overlay.querySelector('[data-lightbox-count]');
    if (!transform || !count) return;
    transform.replaceChildren(makeLightboxMedia(item));
    count.textContent = `${state.index + 1} / ${total}`;
    updateZoomButtons(item);
    overlay.querySelectorAll('[data-lightbox-thumb]').forEach((thumb) => {
      const active = Number(thumb.dataset.lightboxIndex) === state.index;
      thumb.classList.toggle('is-active', active);
      if (active) {
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
    requestAnimationFrame(applyTransform);
  };

  const moveLightbox = (direction) => renderLightbox(state.index + direction);

  const buildLightboxThumbs = (overlay, media) => {
    const thumbs = overlay.querySelector('[data-lightbox-thumbs]');
    if (!thumbs) return;
    thumbs.replaceChildren();
    media.forEach((item, index) => {
      const button = document.createElement('button');
      button.className = 'treedix-media-lightbox__thumb';
      button.type = 'button';
      button.dataset.lightboxThumb = 'true';
      button.dataset.lightboxIndex = String(index);
      button.setAttribute('aria-label', item.thumb.getAttribute('aria-label') || `View media ${index + 1}`);
      const img = item.thumb.querySelector('img');
      if (img) button.appendChild(img.cloneNode(true));
      else button.textContent = item.type.replace('_', ' ');
      if (item.type.indexOf('video') !== -1) {
        const play = document.createElement('span');
        play.className = 'treedix-media-lightbox__play';
        play.setAttribute('aria-hidden', 'true');
        play.textContent = '▶';
        button.appendChild(play);
      }
      thumbs.appendChild(button);
    });
  };

  const openLightbox = (gallery, mediaId, opener) => {
    cleanupLightboxNodes();
    state.overlay = null;
    const overlay = ensureOverlay();
    const media = getMediaItems(gallery);
    if (!media.length) return;
    const activeId = mediaId || getActiveMediaId(gallery) || media[0].mediaId;
    const index = Math.max(0, media.findIndex((item) => String(item.mediaId) === String(activeId)));
    state.gallery = gallery;
    state.media = media;
    state.lastFocused = opener || document.activeElement;
    buildLightboxThumbs(overlay, media);
    resetTransform();
    lockPage();
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    renderLightbox(index);
    const closeButton = overlay.querySelector('[data-lightbox-close]');
    if (closeButton) closeButton.focus({ preventScroll: true });
  };

  function bindOverlay(overlay) {
    on(overlay, 'click', (event) => {
      if (event.target.closest('[data-lightbox-close]')) { event.preventDefault(); closeLightbox(); return; }
      if (event.target.closest('[data-lightbox-zoom-in]')) { event.preventDefault(); zoom(1); return; }
      if (event.target.closest('[data-lightbox-zoom-out]')) { event.preventDefault(); zoom(-1); return; }
      if (event.target.closest('[data-lightbox-fit]')) { event.preventDefault(); resetTransform(); return; }
      if (event.target.closest('[data-lightbox-fullscreen]')) { event.preventDefault(); toggleFullscreen(); return; }
      if (event.target.closest('[data-lightbox-prev]')) { event.preventDefault(); moveLightbox(-1); return; }
      if (event.target.closest('[data-lightbox-next]')) { event.preventDefault(); moveLightbox(1); return; }
      const thumb = event.target.closest('[data-lightbox-thumb]');
      if (thumb) { event.preventDefault(); renderLightbox(Number(thumb.dataset.lightboxIndex) || 0); return; }
      if (event.target === overlay || event.target.hasAttribute('data-lightbox-backdrop')) closeLightbox();
    });

    const stage = overlay.querySelector('[data-lightbox-stage]');
    on(stage, 'pointerdown', (event) => {
      if (!isCurrentImage() || state.scale <= 1) return;
      if (event.target.closest('button, video, iframe, model-viewer')) return;
      event.preventDefault();
      state.isDragging = true;
      state.pointerId = event.pointerId;
      state.dragStartX = event.clientX;
      state.dragStartY = event.clientY;
      state.startTranslateX = state.translateX;
      state.startTranslateY = state.translateY;
      if (stage.setPointerCapture) { try { stage.setPointerCapture(event.pointerId); } catch (error) {} }
      applyTransform();
    });
    on(stage, 'pointermove', (event) => {
      if (!state.isDragging || event.pointerId !== state.pointerId) return;
      event.preventDefault();
      state.pendingX = state.startTranslateX + event.clientX - state.dragStartX;
      state.pendingY = state.startTranslateY + event.clientY - state.dragStartY;
      if (state.rafId) return;
      state.rafId = requestAnimationFrame(() => {
        state.rafId = 0;
        state.translateX = state.pendingX;
        state.translateY = state.pendingY;
        applyTransform();
      });
    });
    const endDrag = (event) => {
      if (!state.isDragging || (event && event.pointerId !== state.pointerId)) return;
      state.isDragging = false;
      state.pointerId = null;
      applyTransform();
    };
    on(stage, 'pointerup', endDrag);
    on(stage, 'pointercancel', endDrag);
    on(stage, 'lostpointercapture', endDrag);

    on(overlay, 'touchstart', (event) => {
      state.touchCanSwipe = state.scale <= 1 && !state.isDragging;
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      state.touchStartX = touch.clientX;
      state.touchStartY = touch.clientY;
    }, { passive: true });
    on(overlay, 'touchend', (event) => {
      if (!state.touchCanSwipe || state.scale > 1 || state.isDragging) return;
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - state.touchStartX;
      const dy = touch.clientY - state.touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) moveLightbox(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  const trapFocus = (event) => {
    if (!state.overlay || state.overlay.hidden || event.key !== 'Tab') return;
    const focusables = Array.from(state.overlay.querySelectorAll('button, [href], video, iframe, model-viewer, [tabindex]:not([tabindex="-1"])')).filter((node) => !node.disabled && node.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  const globalKeydown = (event) => {
    if (!state.overlay || state.overlay.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (isBrowserFullscreen()) toggleFullscreen();
      else closeLightbox();
    } else if (event.key === 'ArrowLeft') { event.preventDefault(); moveLightbox(-1); }
    else if (event.key === 'ArrowRight') { event.preventDefault(); moveLightbox(1); }
    else if (event.key === '+' || event.key === '=') { event.preventDefault(); zoom(1); }
    else if (event.key === '-' || event.key === '_') { event.preventDefault(); zoom(-1); }
    else if (event.key === '0' || event.key.toLowerCase() === 'f') { event.preventDefault(); resetTransform(); }
    else trapFocus(event);
  };

  const syncFromVariant = (root, gallery) => {
    const variantInput = root.querySelector('[data-pxp-main-variant-input]');
    const dataNode = root.querySelector('[data-pxp-variants-json]');
    if (!variantInput || !dataNode || !dataNode.textContent.trim()) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const variant = variants.find((item) => String(item.id) === String(variantInput.value));
    const image = variant && variant.featured_image;
    if (!image || !image.url) return;
    const match = getThumbs(gallery).find((thumb) => thumb.dataset.imageUrl === image.url || thumb.dataset.zoomUrl === image.zoom_url || String(thumb.dataset.imageId || '') === String(image.id || ''));
    if (match) selectMedia(gallery, match.dataset.mediaId);
  };

  const initGallery = (gallery) => {
    if (!gallery || galleryHandlers.has(gallery)) return;
    const root = gallery.closest('[data-treedix-product-experience]') || document;
    const main = gallery.querySelector('[data-pdp-v2-main]');
    const zoomTrigger = gallery.querySelector('[data-pdp-v2-zoom]');
    if (zoomTrigger) {
      zoomTrigger.hidden = true;
      zoomTrigger.setAttribute('aria-hidden', 'true');
      zoomTrigger.setAttribute('aria-label', 'View product media full screen');
      zoomTrigger.setAttribute('title', 'Click to view full screen');
    }

    const galleryClick = (event) => {
      const thumb = event.target.closest('[data-pdp-v2-thumb]');
      if (thumb && gallery.contains(thumb)) { event.preventDefault(); selectMedia(gallery, thumb.dataset.mediaId); return; }
      const prev = event.target.closest('[data-pdp-v2-thumb-prev]');
      const next = event.target.closest('[data-pdp-v2-thumb-next]');
      if (prev || next) { event.preventDefault(); stepMainMedia(gallery, next ? 1 : -1); }
    };
    gallery.addEventListener('click', galleryClick);

    const mainClick = (event) => {
      if (event.target.closest('button, a, video, iframe, input, select, textarea, [role="button"]')) return;
      const activePanel = gallery.querySelector('[data-pdp-v2-panel].is-active');
      if (!activePanel || activePanel.dataset.mediaType !== 'image') return;
      openLightbox(gallery, activePanel.dataset.mediaId, main);
    };
    if (main) main.addEventListener('click', mainClick);

    const variantButtons = Array.from(root.querySelectorAll('[data-pxp-option-value]'));
    const variantHandler = () => window.setTimeout(() => syncFromVariant(root, gallery), 80);
    variantButtons.forEach((button) => button.addEventListener('click', variantHandler));

    galleryHandlers.set(gallery, () => {
      gallery.removeEventListener('click', galleryClick);
      if (main) main.removeEventListener('click', mainClick);
      variantButtons.forEach((button) => button.removeEventListener('click', variantHandler));
    });

    const active = getActiveThumb(gallery);
    if (active) selectMedia(gallery, active.dataset.mediaId, { scroll: false });
    syncArrows(gallery);
  };

  const initAll = (scope = document) => {
    cleanupLightboxNodes();
    Array.from(scope.querySelectorAll('[data-pdp-v2-gallery]')).forEach(initGallery);
  };

  const resizeHandler = () => requestAnimationFrame(() => { if (state.overlay && !state.overlay.hidden) applyTransform(); });
  const fullscreenHandler = () => updateFullscreenButton();
  const sectionLoadHandler = (event) => initAll(event.target || document);
  const sectionUnloadHandler = () => closeLightbox();

  on(document, 'keydown', globalKeydown);
  on(window, 'resize', resizeHandler, { passive: true });
  on(document, 'fullscreenchange', fullscreenHandler);
  on(document, 'webkitfullscreenchange', fullscreenHandler);
  on(document, 'shopify:section:load', sectionLoadHandler);
  on(document, 'shopify:section:unload', sectionUnloadHandler);

  window.__treedixPdpV2Controller = {
    destroy() {
      closeLightbox();
      galleryHandlers.forEach && galleryHandlers.forEach((destroy) => destroy());
      listeners.splice(0).forEach(([target, type, handler, options]) => target.removeEventListener(type, handler, options));
      cleanupLightboxNodes();
      removeNode(state.overlay);
      state.overlay = null;
    }
  };

  initAll();
})();
